import { render, staticRenderFns } from "./goal_home.vue?vue&type=template&id=25a6d838&"
import script from "./goal_home.vue?vue&type=script&lang=js&"
export * from "./goal_home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports